import { Link } from 'react-router-dom';
import { getLatestUpdatesWithComics } from '@/mocks/comics';

export default function LatestUpdates() {
  const updates = getLatestUpdatesWithComics();

  return (
    <section className="py-10 md:py-14 px-4 md:px-6" aria-labelledby="latest-title">
      <div className="mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <h3 id="latest-title" className="text-xl md:text-2xl font-heading text-foreground-950">
            最新更新
          </h3>
          <Link
            to="/category/romance"
            className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            全部更新
            <i className="ri-arrow-right-s-line text-base"></i>
          </Link>
        </div>
        <div className="bg-background-100 rounded-lg overflow-hidden">
          <div className="divide-y divide-background-200">
            {updates.map((item, idx) => (
              <Link
                key={`${item.comicId}-${idx}`}
                to={`/comic/${item.comicId}`}
                className="flex items-center gap-4 px-4 py-3 md:px-6 md:py-4 hover:bg-background-200/50 transition-colors group cursor-pointer"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                  {item.comic && (
                    <img
                      src={item.comic.cover}
                      alt={item.comic.title}
                      className="w-full h-full object-cover object-top"
                    />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm md:text-base text-foreground-800 font-medium group-hover:text-primary-500 transition-colors truncate">
                    {item.chapterTitle}
                  </h4>
                  <p className="text-xs text-foreground-500 mt-0.5 truncate">
                    {item.comic?.title} · {item.comic?.author}
                  </p>
                </div>
                <div className="flex-shrink-0 text-right">
                  <span className="inline-block px-2 py-1 rounded-md bg-accent-500/10 text-accent-400 text-xs">
                    {item.updateTime}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}